export default __webpack_public_path__ + "static/media/Lilting Bone Flute.d50677fb.jpg";